import { colorPalette } from 'presentations/views/styles/color';

export const getHexColor = (color?: string | null) => {
  const defaultColor = colorPalette.primary.www;

  // stringではない、もしくはhex(#rgb, #rrggbb)ではない場合
  if (
    typeof color !== 'string' ||
    /^\#[0-9a-zA-Z]{3}$|^\#[0-9a-zA-Z]{6}$/.test(color) === false
  ) {
    return defaultColor;
  }

  return color;
};

export const convertHexToRGBA = (hexCode: string, opacity: number) => {
  const { r, g, b } = getRGB(hexCode);
  return `rgba(${r},${g},${b},${opacity / 100})`;
};

export const convertHexToRGBIncludeAlpha = (
  hexCode: string,
  alpha: number,
  opacity?: number,
) => {
  const { r, g, b } = getRGB(hexCode);
  const a = alpha / 100;
  const bg = 255 * (1 - a);
  const ar = r * a + bg;
  const ag = g * a + bg;
  const ab = b * a + bg;
  return `rgba(${ar},${ag},${ab},${opacity || 1})`;
};

// W3CのWCAG定義の相対輝度を取得します
// ref: https://gist.github.com/jfsiii/5641126
// from http://www.w3.org/TR/WCAG20/#relativeluminancedef
export const relativeLuminanceW3C = (hexCode: string) => {
  const { r: R8bit, g: G8bit, b: B8bit } = getRGB(hexCode);

  const RsRGB = R8bit / 255;
  const GsRGB = G8bit / 255;
  const BsRGB = B8bit / 255;

  const R =
    RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
  const G =
    GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
  const B =
    BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);

  // For the sRGB colorspace, the relative luminance of a color is defined as:
  const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;

  return L;
};

const getRGB = (hexCode: string): { r: number; g: number; b: number } => {
  let hex = hexCode.replace('#', '');

  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }

  return {
    r: parseInt(hex.substring(0, 2), 16),
    g: parseInt(hex.substring(2, 4), 16),
    b: parseInt(hex.substring(4, 6), 16),
  };
};

export const blendAlphaToHex = (
  hexCode: string,
  alpha: number,
  opacity: number = 1.0,
) => {
  const { r, g, b } = getRGB(hexCode);
  const a = alpha / 100;
  let ar = Math.floor(r * a).toString(16);
  if (ar.length === 1) ar = `0${ar}`;
  let ag = Math.floor(g * a).toString(16);
  if (ag.length === 1) ag = `0${ag}`;
  let ab = Math.floor(b * a).toString(16);
  if (ab.length === 1) ab = `0${ab}`;
  let o = Math.floor(255 * opacity).toString(16);
  if (o.length === 1) o = `0${o}`;
  return `#${ar}${ag}${ab}${o}`;
};
